import { render, staticRenderFns } from "./reason-result.vue?vue&type=template&id=638ca976&scoped=true&"
import script from "./reason-result.vue?vue&type=script&lang=js&"
export * from "./reason-result.vue?vue&type=script&lang=js&"
import style0 from "./reason-result.vue?vue&type=style&index=0&id=638ca976&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638ca976",
  null
  
)

export default component.exports